import React from 'react'
import {get} from "../tools/restful"
import MenuHeader from "./MenuHeader"
import CategoryNav from "./CategoryNav"
import Section from "./Section"
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Link,
    useParams,
    useRouteMatch
  } from "react-router-dom";

class MenuIdPage extends React.Component {
    constructor(props){
        super(props)
        this.state = {
            currentMenu:[]
        }
    }
    componentDidMount(){
        Promise.all([get('menu', this.props.match.params.id)])
        .then(([menu]) => {
            console.log(menu)
            this.setState(
            {currentMenu: menu[0]}
            
        )})
    }
    updateData(){
        Promise.all([get('menu', this.props.match.params.id)])
        .then(([menu]) => this.setState(
            {currentMenu: menu[0]}
        ))
    }
    render(){
        console.log(this.state)
        console.log(this.props)
        return (
            <div>
                <MenuHeader 
                    name={this.state.currentMenu.name ? this.state.currentMenu.name.label : 'loading'} 
                    description={this.state.currentMenu.description} 
                />
                <CategoryNav 
                    menu={this.state.currentMenu} match={this.props.match}
                />
                
           
        
            </div>
        )
    }
}
export default MenuIdPage